// react
import { useState } from 'react';

// material ui
import { Box } from '@mui/material';

// feature-components
import ImageDisplay from '@/features/devices/components/shared/ImageDisplay';

const GatewayImageSection = ({ gateway, t }) => {
  const [imageFailed, setImageFailed] = useState(false);

  const [currentGatewayId, setCurrentGatewayId] = useState(gateway?.GatewayId);
  const [currentImageHash, setCurrentImageHash] = useState(gateway?.ImageHash);

  const imageUrl = (() => {
    if (!gateway?.GatewayId || !gateway?.ImageHash) return null;
    const v = encodeURIComponent(gateway.ImageHash);
    return `/api/v1/Gateway/${encodeURIComponent(gateway.GatewayId)}/Image?v=${v}`;
  })();

  if (
    gateway?.GatewayId !== currentGatewayId ||
    gateway?.ImageHash !== currentImageHash
  ) {
    setCurrentGatewayId(gateway?.GatewayId);
    setCurrentImageHash(gateway?.ImageHash);
    setImageFailed(false);
  }

  const handleImageError = () => setImageFailed(true);

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: 300,
        bgcolor: (theme) => theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <ImageDisplay
        imageUrl={imageUrl}
        imageFailed={imageFailed}
        onImageError={handleImageError}
        t={t}
      />
    </Box>
  );
};

export default GatewayImageSection;
